import * as Case from 'case';
import { PageComponent } from '~contentful/components/page/page.component';
import { ComponentModel } from '~contentful/models/components/component.model';

export class PageModel extends ComponentModel {
    public readonly pageName: string;
    public readonly slug: string;
    public readonly layout: ComponentModel[];
    public readonly componentClass = PageComponent;

    public get contextLabel () {
        return this.pageName;
    }

    public get contextValue () {
        return Case.kebab(this.pageName);
    }
}
